function Peer(id,connection) {
    this.id = id;
    this.connection = connection;
}

export {Peer}
